<template>
  <span class="space-x-2">
    <img
      v-if="serviceAttributeImg"
      :src="serviceAttributeImg"
      class="inline h-6 w-6"
      :alt="service?.name || $t('SCORECARDS.SERVICE')"
      loading="lazy"
    />
    {{ service?.name || $t("SCORECARDS.SERVICE") }}
  </span>
</template>
<script setup lang="ts">
import { computed } from "vue";

import {
  SERVICE_APPLICATION_DATA,
  SERVICE_CUSTOM_ATTRIBUTES,
} from "@/helpers/constants";
import { getImageForService } from "@/helpers/services";
import { useAttributeBuilderServices } from "@/hooks/attributeBuilder";

import type { IStepAttribute } from "@/models/orchestration";

const props = defineProps<{
  item: IStepAttribute;
}>();

const { getService, getServiceProviderDetails } = useAttributeBuilderServices();

const service = computed(() => getService(props.item.id, props.item.context));

const serviceAttributeProviderInfo = computed(() =>
  getServiceProviderDetails(props.item.id)
);

const serviceAttributeImg = computed(() => {
  if (
    serviceAttributeProviderInfo.value?.category &&
    (
      [SERVICE_APPLICATION_DATA, SERVICE_CUSTOM_ATTRIBUTES] as string[]
    ).includes(serviceAttributeProviderInfo.value?.category)
  ) {
    return getImageForService(serviceAttributeProviderInfo.value?.category);
  }
  return getImageForService(serviceAttributeProviderInfo.value?.id);
});
</script>
